<template>
  <b-modal
    size="lg"
    title="Guía Educativa"
    :id="id"
    class="cme-modal modal-recursos"
    :ref="id"
    hide-footer
    @hidden="close"
  >
    <b-row>
      <b-col>
        <h5>{{data.tag}}</h5>
        <img
          v-if="data.type == 'image'"
          :src="$root.setUrlFile(data.file)"
          class="img-preview"
          :alt="data.file"
        />
        <object
          v-if="data.type == 'application'"
          :data="$root.setUrlFile(data.file)"
          type="application/pdf"
          style="width: 100%; height:800px;"
        >
          <embed
            :src="$root.setUrlFile(data.file)"
            type="application/pdf"
          />
        </object>
        <video width="100%" controls v-if="data.type == 'video'">
          <source
            :src="$root.setUrlFile(data.file)"
            type="video/mp4"
          />Your browser does not support HTML5 video.
        </video>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: "ModalVisualizarGuia",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    guia: {
      type: Object,
      default: null
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      data: ""
    };
  },
  watch: {
    guia: function(data) {
      console.log(data);
      this.data = data;
    },
    showModal: function(data) {
      if (data) {
        this.$refs[this.id].show();
        console.log(this.id);
      }
    }
  },
  methods: {
    close() {
      this.flagSearch = false;
      this.$emit("closeModal", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.video-preview,
.img-preview {
  display: block;
  margin: auto;
  max-width: 100%;
  border: solid 0.5rem #8f9ba6;
  border-radius: 0.2rem;
}

.audio-preview {
  display: block;
  margin: auto;
}
.modal-recursos .modal-dialog {
  max-width: 80vw !important;
}

.btn-card {
  cursor: pointer;

  &:hover {
    border-color: #63c2de;
  }
}
</style>